import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import http, { wxAppid, redirectUri } from '../../lib/http'
import * as apis from '../../lib/apis'
import { isWeChatBrowserOrMiniProgram } from '../../lib/http'
import getBrowserFingerprint from '../../lib/fingerprint'
import md5 from 'md5'
import axios from 'axios'



const Index = () => {
    const l = useLocation()

    useEffect(() => {

        // const brower = isWeChatBrowserOrMiniProgram()
        // if (brower === "Not WeChat Browser or Mini Program") {
        //     (async () => {
        //         const fp = await getBrowserFingerprint();
        //         const fp_md5 = md5(fp)
        //         axios.post(`${apis.GUEST_LOGIN}?openid=${fp_md5}`).then((data: any) => {
        //             window.location.replace(`/cloth/h5/entry/${data.data.data}`)
        //         })
        //     })();
        // } else {
        //     const urlParam = new URLSearchParams(l.search)
        //     const code = urlParam.get("code")
        //     if (code) {
        //         http.post(`${apis.WX_LOGIN}?appid=${wxAppid}&code=${code}`).then((token: any) => {
        //             window.location.replace(`/cloth/h5/entry/${token}`)
        //         })
        //     } else {
        //         window.location.replace(redirectUri)
        //     }
        // }
    }, [])

    return null
}

export default Index